import type { ProfileConfig } from "@worker/config-schema";
import { el } from "../lib/dom";
import { resolveAsset } from "../lib/assets";

/**
 * Badge row. If a badge's `icon` looks like an asset path (starts with `/`,
 * `r2://`, or `http`), it's rendered as an image — supporting GIFs and custom
 * uploads. Otherwise it's shown as a text glyph (emoji or Unicode character).
 */
export function mountBadges(
  badges: ProfileConfig["profile"]["badges"],
): HTMLElement {
  const row = el("div", {
    class: "badges",
    role: "list",
    "aria-label": "Badges",
  });
  for (const b of badges) {
    const badge = el("span", {
      class: "badge",
      role: "listitem",
      tabindex: "0",
      "data-tooltip": b.tooltip ?? b.label,
      "aria-label": b.label,
      style: b.color ? `--badge-color:${b.color};color:${b.color}` : null,
    });
    if (isAssetIcon(b.icon)) {
      badge.append(
        el("img", {
          class: "badge__img",
          src: resolveAsset(b.icon),
          alt: "",
          draggable: false,
        }),
      );
    } else {
      badge.append(b.icon);
    }
    row.append(badge);
  }
  return row;
}

function isAssetIcon(icon: string): boolean {
  return (
    icon.startsWith("/bio-uploads/") ||
    icon.startsWith("/uploads/") ||
    icon.startsWith("r2://") ||
    icon.startsWith("http://") ||
    icon.startsWith("https://") ||
    icon.startsWith("data:")
  );
}
